export const useCart = () => useState<object>('cart', () => ({}));
